export const getOrganizationInitials = (organizationName: string) => {
  const words = organizationName?.split?.(' ');
  if (words) {
    const firstWord = words[0];
    const secondWord = words[1];
    const firstLetter = firstWord[0];
    const secondLetter = secondWord ? secondWord[0] : firstWord[1] || '';
    return `${firstLetter}${secondLetter}`.toUpperCase();
  }
  return '';
};

export interface OrganizationAddress {
  addressLine1?: string;
  address?: string;
  city?: string;
  state?: string;
}

export const getOrganizationAddress = (organization: OrganizationAddress) => {
  return [organization?.addressLine1 || organization?.address, organization?.city, organization?.state]
    .map((component) => component?.trim())
    .filter((component) => !!component)
    .join(', ');
};
